import React, { useEffect } from "react";
import { connect } from "react-redux";
import * as layoutService from "../../view/layoutService";
import { useHistory } from "react-router-dom";
import { withMainLayout } from "../../view/LayoutHOCs";
import RemoteSyslogServerSection from "./RemoteSyslogServerSection";
import { InfoBoxes } from "../../info-boxes/InfoBoxes";

const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "Remote Syslog Server",
        redirectTo: "/syslog-server",
    }
]

function RemoteSyslogServerPage({ userCapability }) {

    const history = useHistory();

    useEffect(() => {
        layoutService.setPageTitle('Remote Syslog Server')
        layoutService.setBreadcrumbs(breadcrumbs)
    }, [history.location])

    //#region Set User Capabilities
    const checkCapability = async () => {
        try {
            if (userCapability) {
                const capability = userCapability.find(item =>
                    item.component === "systemsettings" && item.type === "page")?.permission;
                if (capability === -1) {
                    sessionStorage.removeItem('access_token');
                    window.location.reload();
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        checkCapability();
        /* eslint-disable react-hooks/exhaustive-deps */
    }, []);
    //#endregion


    return (
        <>
            <InfoBoxes />
            <RemoteSyslogServerSection />
        </>
    )

}

function mapStateToProps(state) {
    const auth = state.auth;
    return {
        userCapability: auth.userCapability,
    }
}

export default withMainLayout(connect(mapStateToProps)(RemoteSyslogServerPage));